<div class="page-filter-bar-row">
  <div class="page-filter-bar-controls" data-testid="page-filter-bar-controls">
    @if (config().templateService; as templates) {
      <soft-page-filter-templates-dropdown [templateService]="templates"
                                           (manage)="config().open({ view: 'templates' })" />
    }
    @if (leading(); as template) {
      <ng-container *ngTemplateOutlet="template" />
    }
    <soft-page-filter-menu-bar [config]="config()" />
    @if (trailing(); as template) {
      <ng-container *ngTemplateOutlet="template" />
    }
  </div>
  <div class="page-filter-bar-actions">
    <soft-ds-button variant="ghost" size="lg" (click)="reset()" data-testid="page-filter-bar-reset">
      {{ '#CORE_FILTER.MENU_BAR.RESET' | translate }}
    </soft-ds-button>
    <soft-ds-button variant="outline" size="lg" (click)="open()" data-testid="page-filter-bar-open">
      <ng-template softSlot="leading">
        <soft-ds-icon name="fa-regular fa-filter" />
      </ng-template>
      {{ '#CORE_FILTER.MENU_BAR.FILTER' | translate }}
    </soft-ds-button>
  </div>
</div>
<soft-page-filter-chips [config]="config()" />
